'use client'

import React, { createContext, useContext } from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'

import { defaultTheme, Theme } from '../../themes'

const ThemeContext = createContext(defaultTheme)

export const useTheme = (): Theme => {
  return useContext(ThemeContext)
}

export interface ThemeProviderProps {
  theme?: Theme
  children: React.ReactNode
}

export const ThemeProvider = ({ theme, children }: ThemeProviderProps) => (
  <ThemeContext.Provider value={theme ?? defaultTheme}>
    <SCThemeProvider theme={theme ?? defaultTheme}>{children}</SCThemeProvider>
  </ThemeContext.Provider>
)
